export default {
  title: '生產管理',
  productionPlan: '生產計劃',
};
